module.exports = __webpack_public_path__ + "static/og-image-datenschutz-84019a8cedb7b9ad9edd2c4daca65679.png";